import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { set } from "@thi.ng/vectors";
import { Polyline } from "../api/polyline";
import { copyAttribs } from "../internal/copy-attribs";
import { dispatch } from "../internal/dispatch";
import { vertices } from "./vertices";
export const asPolyline = defmulti(dispatch);
asPolyline.addAll({
    [Type.CUBIC]: ($, opts) => new Polyline(vertices($, opts)),
    [Type.POINTS]: ($, opts) => new Polyline(vertices($, opts), copyAttribs($)),
    [Type.PATH]: ($, opts) => {
        const pts = vertices($, opts);
        $.closed && pts.push(set([], pts[0]));
        return new Polyline(pts, copyAttribs($));
    },
    [Type.POLYGON]: ($, opts) => {
        const pts = vertices($, opts);
        pts.push(set([], pts[0]));
        return new Polyline(pts, copyAttribs($));
    },
});
asPolyline.isa(Type.ARC, Type.CUBIC);
asPolyline.isa(Type.CIRCLE, Type.POLYGON);
asPolyline.isa(Type.ELLIPSE, Type.POLYGON);
asPolyline.isa(Type.LINE, Type.POINTS);
asPolyline.isa(Type.POLYLINE, Type.POINTS);
asPolyline.isa(Type.QUAD, Type.POLYGON);
asPolyline.isa(Type.QUADRATIC, Type.CUBIC);
asPolyline.isa(Type.RECT, Type.POLYGON);
asPolyline.isa(Type.TRIANGLE, Type.POLYGON);
